/**
 * Voice Memo Breadcrumb Component
 * Shows navigation path: Voice Memos / Package / Memo
 */

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface VoiceMemoBreadcrumbProps {
  items: BreadcrumbItem[];
}

export function VoiceMemoBreadcrumb({ items }: VoiceMemoBreadcrumbProps) {
  return (
    <nav className="flex items-center gap-2 text-sm" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={index} className="flex items-center gap-2">
            {item.onClick ? (
              <button
                onClick={item.onClick}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {item.label}
              </button>
            ) : (
              <span className={isLast ? 'font-semibold text-foreground' : 'text-muted-foreground'}>
                {item.label}
              </span>
            )}
            {!isLast && <span className="text-muted-foreground">/</span>}
          </div>
        );
      })}
    </nav>
  );
}
